import React from "react";
import Session, { useSession } from "../../utils/Session";
import { Space } from "antd";

export default function Availability(props) {

    const [session, setSession] = useSession();
    const { data = [] } = props;


    // {
    //     "store_san": "1187430",
    //     "availability": [
    //       {
    //         "code": "",
    //         "text": "",
    //         "price": "22.95",
    //         "row_price": "22.95",
    //         "used": false,
    //         "note": "",
    //         "onhand": "2",
    //         "discount": 0,
    //         "availability": "available",
    //         "is_extra_orderable": true,
    //         "message": "2 in store",
    //         "sub_message": "(more on order)"
    //       }
    //     ]
    //   },

    const getStoreName = (_san) => {

        let _f = session.stores_working_with.find(item => item.san === _san);
        if (_f) {
            return _f.name;
        }

        return "";

    }


    const drawRow = (item) => {

        const {
            store_san = "",
            availability = []
        } = item;

        return (
            <div>

               
                    <div style={{ "fontSize": "11px", "fontWeight": "normal" }}><strong>{getStoreName(store_san)}</strong></div>
                    <Space size={3} direction="vertical">
                      
                        {availability.map((i) => {

                            const {
                                code = "",
                                text = "",
                                price = "22.95",
                                row_price = "22.95",
                                used = false,
                                note = "",
                                onhand = "2",
                                discount = 0,
                                availability = "available",
                                is_extra_orderable = true,
                                message = "2 in store",
                                sub_message = "(more on order)"
                            } = i;

                            return (<div style={{ "fontSize": "11px", "fontWeight": "normal" }}><span>&nbsp;&nbsp;${row_price} {text} - </span><strong style={{"color" : (onhand) ? "#228B22" : "#e77e21" }}>{message}</strong><span style={{ "opacity": "0.7" }}> {sub_message}</span></div>)
                        })}
                    </Space>
                    <div className="shim" /><div className="shim" />
                    
            </div>)

    }





    return (<div>
        <div className="shim" />
        {data.map((item) => {
            return (<div>{drawRow(item)}</div>)
        })}
        
        <div className="shim" />

    </div>)



}